module.exports = __webpack_public_path__ + "img/23.e7943737.svg";